import React from "react";

import { AsyncSelect, Section } from "@samskip/frontend-components";
import { Control } from "react-hook-form";
import { useTranslation } from "react-i18next";

import { LabelConstants } from "@assets/constants";
import { BookingTemplateFormTypes } from "@assets/formTypes";
import {
  hsCodesLabelMapper,
  hsCodesValueMapper,
} from "@assets/utilities/labelMapperUtils";
import { WithFormController } from "@components";
import RegistryService from "@services/RegistryService";

type HSCodesSectionProps = {
  control: Control<BookingTemplateFormTypes.CargoForm>;
};

const HSCodesSection = ({ control }: HSCodesSectionProps) => {
  const { t } = useTranslation();

  const searchHSCodes = (searchString: string) =>
    RegistryService.searchHSCodes(searchString);

  return (
    <Section title={t("LABEL_HS_CODES")}>
      <WithFormController control={control} name="HSCodes">
        <AsyncSelect
          className="flex w-3/4"
          defaultOptionsMessage={t(
            LabelConstants.SELECT_LABELS.DEFAULT_OPTIONS_MESSAGE
          )}
          fullWidth
          getOptionLabel={hsCodesLabelMapper}
          getOptionValue={hsCodesValueMapper}
          id="HSCodes"
          isClearable
          isMulti
          isSearchable
          label={t("LABEL_HS_CODES")}
          loadOptions={searchHSCodes}
          noOptionsMessage={t(LabelConstants.SELECT_LABELS.NO_OPTIONS)}
          placeholder={t("PLACEHOLDER_HS_CODES")}
        />
      </WithFormController>
    </Section>
  );
};

export default HSCodesSection;
